import { render, staticRenderFns } from "./TextSwitchingTabsIcons.vue?vue&type=template&id=259321ad"
import script from "./TextSwitchingTabsIcons.vue?vue&type=script&lang=js"
export * from "./TextSwitchingTabsIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports